export const UserGuidesReservoir = {
  LIBRARY: 'GUIAS_Biblioteca',
  CATEGORIES: 'GUIAS_Categorias_Guias_Rapidas_de_Uso',
  ITEMS: 'GUIAS_Guias_Rapidas_de_Uso',
};
